import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-left: -4;\n        margin-right: -4;\n        border-radius: 0;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n        font-size: 22;\n        line-height: 1.3;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n        overflow-wrap: break-word;\n        word-break: break-word;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n        font-size: 30;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n        font-size: 48;\n        font-weight: 700;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n        font-size: 24;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        font-size: 16;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n        border-radius: editor;\n        margin: 3 -2;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  .anchor {\n    fill: on-background;\n  }\n\n  code {\n    background-color: background-light;\n    color: on-background-primary;\n    border-radius: base;\n    padding: 0 1;\n  }\n\n  mark {\n    background-color: background-mark;\n  }\n\n  > pre,\n  > summary > pre {\n    overflow: auto;\n    direction: ltr;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    margin: 3 -3;\n    background-color: editor-background;\n    color: editor-on;\n    direction: ltr;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    hyphens: none;\n    border-left: ", " solid transparent;\n    border-right: ", " solid transparent;\n\n    ", "\n  }\n\n  > p {\n    margin-top: 4;\n    font-size: 17;\n    line-height: 1.7;\n    max-width: 52em;\n\n    &:first-of-type {\n      margin-top: 3;\n    }\n\n    ", "\n  }\n\n  /* Intro */\n  > h1 + p {\n    font-size: 18;\n    font-weight: 300;\n    color: on-background-light;\n    margin: 2 0 !important;\n\n    ", ";\n\n    a,\n    strong {\n      font-weight: 400;\n    }\n  }\n\n  > hr {\n    margin: 0;\n    height: 0;\n    border: 0;\n    border-top: 1;\n    border-color: layout-border;\n    margin: 4 0;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  > h1 {\n    font-size: 40;\n    line-height: 1.1;\n    font-weight: 600;\n    margin-bottom: 2;\n    margin-top: 40;\n\n    ", ";\n  }\n\n  > h2 {\n    border-top: 1;\n    border-color: layout-border;\n    margin-top: 5;\n    padding-top: 4;\n    line-height: 1.2;\n    font-size: 20;\n\n    ", ";\n  }\n\n  > h1 + h2,\n  > h2:first-child {\n    border-top: 0;\n    margin-top: 0;\n    padding-top: 0;\n  }\n\n  > h3 {\n    font-size: 20;\n    padding-top: 4;\n\n    ", "\n\n    ", "\n  }\n\n  > h4 {\n    margin-top: 5;\n    font-weight: 500;\n    font-size: 18;\n    line-height: 1.3;\n  }\n\n  > h2 + h3,\n  > h2 + h3:first-of-type {\n    padding-top: 3;\n  }\n\n  > h4 + p {\n    margin-top: 3;\n  }\n\n  > ul + p {\n    margin-top: 2;\n  }\n\n  .editor {\n    background-color: editor-background;\n    color: editor-text;\n    padding: 3 4;\n    margin: 4 -3;\n    overflow: auto;\n    font-size: 14;\n    line-height: 1.45;\n    border-radius: base;\n\n    ", "\n  }\n\n  > code {\n    background-color: editor-background;\n    border-radius: base;\n    color: inherit;\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono,\n      Courier New, monospace;\n    font-size: 85%;\n    padding: 1 2;\n  }\n\n  > table {\n    display: block;\n    border-collapse: collapse;\n    border-spacing: 0;\n    margin-bottom: 2;\n    margin-top: 3;\n    overflow: auto;\n    width: 100%;\n    text-align: left;\n    font-size: 95%;\n\n    tr {\n      background-color: transparent;\n      border-top: 1;\n      border-color: layout-border;\n    }\n\n    td,\n    th {\n      border-top: 1;\n      border-bottom: 1;\n      border-color: layout-border;\n      padding: 2 3;\n    }\n\n    th {\n      color: on-background-light;\n      background-color: background-light;\n      font-weight: 600;\n      font-size: 100%;\n    }\n\n    td {\n      font-size: 85%;\n    }\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  ol,\n  ul {\n    margin-top: 4;\n    font-size: 16;\n    padding-left: 4;\n\n    p,\n    p:first-of-type {\n      font-size: 16;\n      margin-top: 0;\n      line-height: 1.2;\n    }\n\n    li {\n      margin-top: 2;\n    }\n\n    ol,\n    ul {\n      margin-left: 4;\n      margin-top: 2;\n    }\n  }\n\n  ol {\n    list-style: decimal;\n  }\n\n  ul {\n    list-style: disc;\n  }\n\n  > blockquote {\n    font-size: 16;\n    background-color: blockquote-background;\n    border-left: 8;\n    border-color: blockquote-border;\n    padding: 3;\n    margin: 3 -2;\n    border-radius: blockquote;\n\n    code {\n      background-color: rgba(255, 255, 255, 0.1);\n      background-blend-mode: color;\n      color: on-background;\n      border-radius: base;\n      padding: 0 1;\n    }\n\n    p {\n      margin-top: 3;\n\n      &:first-of-type {\n        margin-top: 0;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    a {\n      transition: fast;\n      color: blockquote-link;\n      text-decoration: underline;\n\n      &:hover {\n        color: on-background;\n      }\n    }\n  }\n\n  a {\n    transition: fast;\n    text-decoration: underline;\n    color: on-background-primary;\n\n    &:hover {\n      color: on-background-primary-dark;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css, up, down, th } from '@xstyled/styled-components';
export var Article = styled.article(_templateObject(), th.space(4), th.space(4), up('sm', css(_templateObject2())), up('lg', css(_templateObject3())), up('xl', css(_templateObject4())), up('md', css(_templateObject5())), up('lg', css(_templateObject6())), down('sm', css(_templateObject7())), up('xl', css(_templateObject8())), down('sm', css(_templateObject9())));